var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Loading from 'components/UI/LoadingScreen';
import { getPaymentMethods } from 'actions/PaymentMethod';
function DinteroPaymentMethodCallbackHandler() {
    useEffect(() => {
        const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
        const redirectToPaymentMethods = () => __awaiter(this, void 0, void 0, function* () {
            yield sleep(5000);
            getPaymentMethods();
            window.location.href = '/my-page/payment-methods';
        });
        redirectToPaymentMethods();
    }, []);
    return React.createElement(Loading, null);
}
export default connect()(DinteroPaymentMethodCallbackHandler);
